export const EXTERNAL_APP_BASE_URL = 'https://www.clickguard.com'
export const AFFILIATE_BRANDING_RESOURCES_URL =
	'https://drive.google.com/drive/folders/1xhSEB9wgYb_kJThfUtH2BouoLcCNgvnD?usp=sharing'
